import { useApiAction } from '../action/useApiAction'
// eslint-disable-next-line import/no-unresolved
import { postCrmCustomerMeNewsletterSubscribe } from 'data-api'
import { useCallback } from 'react'
import { useTrackingsActions } from '../trackings/useTrackingsActions'

export const useCustomerNewsletterSubscribe = () => {
	const { subscribeNewsletter: trackingSubscribeNewsletter } = useTrackingsActions()
	const method = useCallback(
		async ({ client, source }) => {
			const { data } = await postCrmCustomerMeNewsletterSubscribe({ client, source })
			if (data) {
				trackingSubscribeNewsletter({ source })
			}
		},
		[trackingSubscribeNewsletter]
	)

	const { action, loading, error } = useApiAction({
		method,
	})

	return {
		action,
		loading,
		error,
	}
}
